export default "__VITE_ASSET__DbB74vG$__"